// extracted by mini-css-extract-plugin
export default {"root":"style_root__f1+9T","pageTitle":"style_pageTitle__S+FWp","pageSubtitle":"style_pageSubtitle__Kn4XQ"};